module.exports = __webpack_public_path__ + "images/company_profile/icon_en05-52e4383adfd2af246316cb5d87bac322.png";